<app-collapsible-section heading="Excellence Lever KPI" [count]="groups.itemCount" [collapsible]="false">
  @if (defaults.isMersyAdminBranchExcellenceUser) {
    <div section-actions class="OrangeButton section-buttons">
      <button mat-raised-button (click)="onClickDownload()" title="Download Lever KPI file" class="btn btn-sm button-color-fix">
        <mat-icon class="add-button icon-color-fix">download</mat-icon>Download Lever KPI
      </button>
      <button mat-raised-button (click)="onClickUpload()" title="Upload Lever KPI file" class="btn btn-sm button-color-fix">
        <mat-icon class="add-button icon-color-fix">upload</mat-icon>Upload Lever KPI
      </button>
      <button mat-raised-button (click)="openCreateExcellenceLeverKPIPopup()" title="Create new Excellence Lever KPI" class="btn btn-sm button-color-fix">
        Add Lever KPI <mat-icon class="add-button icon-color-fix">add_box</mat-icon>
      </button>
      <button mat-raised-button (click)="toggleRemoveLeverKpi()" title="Remove Lever KPI" class="btn btn-sm button-color-fix">
        <mat-icon class="add-button icon-color-fix">remove_circle</mat-icon>
        Remove Lever KPI
      </button>
    </div>
  }

  <div class="admin-table-scroll full-height mat-elevation-z8">
    <table mat-table #itemsList
      [dataSource]="groups.rows"
      class="mat-table-custom" id="excellenceleverkpi">

      <ng-container matColumnDef="groupHeader">
        <td mat-cell *matCellDef="let group" [attr.colspan]="columnsToDisplay.length" class="group-header-cell">
          <button type="button" class="group-toggle"
            [attr.aria-expanded]="groups.isExpanded(group.groupFunction)"
            (click)="groups.toggle(group.groupFunction)">
            <mat-icon class="group-toggle-icon" aria-hidden="true">{{groups.isExpanded(group.groupFunction) ? 'expand_less' : 'expand_more'}}</mat-icon>
            <strong>{{group.groupFunction}}</strong>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="ExcellenceLever">
        <th mat-header-cell *matHeaderCellDef>
          @if (isRemoveActive) {
            <mat-checkbox class="select-all-checkbox"
              matTooltip="Select all visible lever KPIs"
              aria-label="Select all visible lever KPIs"
              [disabled]="groups.visibleItems.length === 0"
              [checked]="selection.isAllSelected(groups.visibleItems)"
              [indeterminate]="selection.isPartiallySelected(groups.visibleItems)"
              (change)="selection.setAllSelected(groups.visibleItems, $event.checked)">
            </mat-checkbox>
          }
          <button type="button" class="group-toggle-all"
            [matTooltip]="groups.allExpanded ? 'Collapse all groups' : 'Expand all groups'"
            [attr.aria-label]="groups.allExpanded ? 'Collapse all groups' : 'Expand all groups'"
            (click)="groups.toggleAll()">
            <mat-icon aria-hidden="true">{{groups.allExpanded ? 'unfold_less' : 'unfold_more'}}</mat-icon>
          </button>
          Excellence Lever
        </th>
        <td mat-cell *matCellDef="let element"
          [ngClass]="{'clickable-cursor': isRemoveActive}">
          <div class="defCheckbox">
            @if (isRemoveActive) {
              <mat-checkbox
                [aria-label]="'Select ' + element.ExcellenceLever + ' - ' + element.KpiName"
                [checked]="selection.isSelected(element)"
                (change)="selection.setSelected(element, $event.checked)">
              </mat-checkbox>
            }
            <p [innerHTML]="element.ExcellenceLever"></p>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="KpiName">
        <th mat-header-cell *matHeaderCellDef> KPI </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.KpiName"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button matTooltip="Edit Excellence Lever KPI" (click)="onEditExcellenceLeverKPI(element)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Remove Excellence Lever KPI" (click)="onRemoveExcellenceLeverKPI(element)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="ChangeLog">
        <th mat-header-cell *matHeaderCellDef>Change Log</th>
        <td mat-cell *matCellDef="let element">
          <compact-history-button
            [item]="element"
            tooltip="View Change Log"
            buttonText="Get History"
            (historyClick)="onHistoryDetail($event, 'ExcellenceLeverKpi')">
          </compact-history-button>
        </td>
      </ng-container>

      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let group; when: groups.isGroupRow; columns: ['groupHeader']"
        class="group-header-row"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
        class="item"
        [style.display]="groups.isItemVisible(element) ? '' : 'none'">
      </tr>
    </table>
  </div>

  @if (isRemoveActive) {
    <div class="stickypanel_KPI">
      @if (selection.hasValue()) {
        <div class="col-lg-6" style="width:50%">
          Total selected lever KPIs: {{selection.count}}
        </div>
        <div class="col-lg-6">
          <button class="btn btn-realease btn-sm pull-right button-margin" (click)="onClickBulkRemove()">
            Remove selected lever KPIs
          </button>
        </div>
      } @else {
        <div class="col-lg-6" style="width:50%">
          Please select at least one Lever KPI
        </div>
      }
    </div>
  }
</app-collapsible-section>
